"use strict";
import Swiper from "swiper";
import { Navigation, Pagination } from "swiper/modules";

export default function () {
    document.addEventListener("DOMContentLoaded", () => {
        const section = document.querySelector(".o-home-testimonials");
        if (!section) return;

        const sliderEl = section.querySelector(
            ".o-home-testimonials__list.swiper",
        );
        if (!sliderEl) return;

        // pega o bloco "ativo" (o que estiver visível no breakpoint)
        const getActiveControls = () => {
            const desktop = section.querySelector(
                ".o-home-testimonials__header .o-home-testimonials__arrows",
            );
            const mobile = section.querySelector(
                ".o-home-testimonials__list .o-home-testimonials__arrows",
            );

            const isVisible = (el) => el && el.offsetParent !== null;

            if (isVisible(desktop)) return desktop;
            if (isVisible(mobile)) return mobile;

            return desktop || mobile;
        };

        const getControls = () => {
            const wrap = getActiveControls();
            if (!wrap) return {};

            return {
                prevEl: wrap.querySelector(".o-home-testimonials__arrow--prev"),
                nextEl: wrap.querySelector(".o-home-testimonials__arrow--next"),
                paginationEl: wrap.querySelector(".swiper-pagination"),
            };
        };

        const swiper = new Swiper(sliderEl, {
            modules: [Navigation, Pagination],
            slidesPerView: 1,
            spaceBetween: 26,
            autoHeight: true,
            loop: true,

            navigation: {
                prevEl: getControls().prevEl,
                nextEl: getControls().nextEl,
            },

            pagination: {
                el: getControls().paginationEl,
                type: "fraction",
                clickable: false,
            },
        });

        const updateControls = () => {
            const { prevEl, nextEl, paginationEl } = getControls();
            if (!prevEl || !nextEl || !paginationEl) return;

            // atualiza refs
            swiper.params.navigation.prevEl = prevEl;
            swiper.params.navigation.nextEl = nextEl;
            swiper.params.pagination.el = paginationEl;

            // rebind navigation
            swiper.navigation.destroy();
            swiper.navigation.init();
            swiper.navigation.update();

            // rebind pagination
            swiper.pagination.destroy();
            swiper.pagination.init();
            swiper.pagination.render();
            swiper.pagination.update();
        };

        window.addEventListener("resize", updateControls);
        updateControls();
    });
}
